import { NavLink, Link } from "react-router-dom";
import { Home, Plus, MessageCircle, ClipboardList, Trophy, User } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const NAV_ITEMS = [
  { to: "/", icon: Home, label: "Feed" },
  { to: "/create", icon: Plus, label: "Create" },
  { to: "/chats", icon: MessageCircle, label: "Chat" },
  { to: "/activity", icon: ClipboardList, label: "Activity" },
  { to: "/leaderboard", icon: Trophy, label: "Board" },
  { to: "/profile", icon: User, label: "Profile" },
];

export default function Sidebar() {
  const { user, switchUser, seedUsers } = useAuth();

  return (
    <aside className="hidden md:flex md:flex-col md:w-60 md:fixed md:inset-y-0 bg-cream border-r border-stone">
      <div className="p-6">
        <Link to="/" className="font-display text-xl font-bold text-walnut">
          Good <span className="text-terracotta">Place</span>
        </Link>
      </div>

      <nav className="flex-1 px-3 space-y-1">
        {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? "text-terracotta bg-terracotta/10 border-l-2 border-terracotta"
                  : "text-walnut-light hover:text-walnut hover:bg-linen"
              }`
            }
          >
            <Icon size={20} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-stone">
        <select
          value={user?.id || ""}
          onChange={(e) => {
            const selected = seedUsers.find((u) => u.id === e.target.value);
            if (selected) switchUser(selected);
          }}
          className="w-full px-3 py-2 bg-linen border border-stone rounded-md text-sm text-walnut font-medium focus:outline-none focus:ring-2 focus:ring-terracotta/30"
        >
          {seedUsers.map((u) => (
            <option key={u.id} value={u.id}>
              {u.display_name}
            </option>
          ))}
        </select>
      </div>
    </aside>
  );
}
